import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {Diamonds} from '../Components/Diamonds'
import {RealCampusFooter} from './RealCampusFooter'
import {browserHistory} from 'react-router'
import * as Request from '../tgccRequest'
import {RealCampusOrderRoster} from './RealCampusOrderRoster'
import {CampusProofCard} from '../Components/CampusProofCard'
import {RealCampusHdr} from './RealCampusHdr'
import {RealCampusFeedback} from './RealCampusFeedback'
const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    height: 'auto',
    width: '100%',
}

const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor:'#E9E6E6',
    borderRadius:'20px',
    width:'748px',
    height:'auto',
    margin:'auto'
}

const statusStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '16px',
    letterSpacing: '3px',
    fontWeight: 100,
    textTransform: 'uppercase',
    textAlign: 'center',
    marginBottom: '10px',
    marginTop:'22px',
    color: '#616060',
    fontFamily:'BarlowMedium',
    '@media(max-width:414px)': {
        fontSize:'16px'
    },
    '@media(max-width:375px)': {
        fontSize:'15px'
    },
    '@media(max-width:320px)': {
        fontSize:'12px'
    }
}
const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'BarlowMedium',
    color:'#616060'
}
const createAcc: React.CSSProperties ={
    textAlign:'center',
}

const proofIdStyle: React.CSSProperties = {
    textAlign:'center',
    position:'relative',
    top:'25px',
    fontFamily:'BarlowMedium',
    color:'#616060',
    fontSize:'24px'
}
const status: React.CSSProperties = {
    color:'#E27558'
}
class pageState {
    proof:  Tgcc.Proof;
}

class _RealCampusProofRoster extends React.Component<Tgcc.BaseProps, any>{
    state = new pageState();

    init = (login: Tgcc.LoginData) => {
        if(login){
            var proofId = this.props.location.query.proofId;
            Request.getProof(login, proofId, this.proofLoaded, this.loadError);
        }
    }

    componentWillMount(){
        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser( this.props.dispatch);
    }
    
    componentWillReceiveProps(props: any){
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }
    componentDidMount(){
        var tag = document.getElementById('roster');
        if(tag != null){
            tag.scrollIntoView(false);
        }        
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    proofLoaded = (proof: Tgcc.Proof) => {
        this.setState({proof: proof});
    }

    loadError = (err: any) => {
        console.log("error loading proof: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    getRosters = () => {
        if(this.state.proof && this.state.proof.rosterCodes && this.state.proof.rosterCodes.length){
            var rosters = new Array();
            this.state.proof.rosterCodes.map( (value: string) => {
                rosters.push(<RealCampusOrderRoster key={value} rosterCode={value}/>);
            });
            return rosters;
        }
        return null;
    }
    getDashHeader(){
        return (
            <div style={createAcc} className="createAcct">
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>ORDER ROSTER</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }


    render(){
        var proof: Tgcc.Proof = this.state.proof;
        if(!proof)
            return null;

        if(!this.props.state.LoginData)
            return null;

        var orderRosters = this.getRosters();
       
        return (
                <div style={wrapperStyle}>
                <div id='roster'></div>
                <RealCampusHdr />
                <RealCampusFeedback state={this.props.state} />
                {this.getDashHeader()}  
                    <div style={contentStyle} className="campusProofCont">
                        <div style={proofIdStyle}>{proof.proofId}</div>
                        <div style={statusStyle}>Order Status: <span style={status}>{proof.status}</span></div>
                        <CampusProofCard proofId={proof.proofId} />
                        {orderRosters}
                    </div>
                    <RealCampusFooter state={this.props.state} />

                 </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { 
        state: state,
    }
};

export var RealCampusProofRoster = connect(mapStateToProps)(Radium(_RealCampusProofRoster));